import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faPlus } from "@fortawesome/pro-solid-svg-icons";

import { ButtonNew } from "components/buttonNew";
import ButtonGroup from "components/button/ButtonGroup";

type TBookingFeeSearchEmptyStateProps = {
  title: string;
  description: string;
  descriptionSecondary?: string;
  clearLabel: string;
  createLabel?: string;
  clearDisabled?: boolean;
  onClearSearch: () => void;
  onCreate?: () => void;
};

export default function BookingFeeSearchEmptyState(props: TBookingFeeSearchEmptyStateProps) {
  const { title, description, descriptionSecondary, clearLabel, createLabel, clearDisabled, onClearSearch, onCreate } =
    props;

  return (
    <div className="booking-fees__product-empty">
      <div className="booking-fees__product-empty-body">
        <div className="booking-fees__product-empty-content">
          <span className="booking-fees__product-empty-icon" aria-hidden="true">
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </span>
          <div className="booking-fees__product-empty-text">
            <p className="booking-fees__product-empty-title">{title}</p>
            <p className="booking-fees__product-empty-support">
              {description}
              {descriptionSecondary ? (
                <>
                  <br />
                  {descriptionSecondary}
                </>
              ) : null}
            </p>
          </div>
        </div>
        <div className="booking-fees__product-empty-actions">
          <ButtonGroup>
            <ButtonNew size="small" type="secondary" onClick={onClearSearch} disabled={clearDisabled}>
              {clearLabel}
            </ButtonNew>
            {onCreate && createLabel ? (
              <ButtonNew size="small" type="primary" onClick={onCreate}>
                <FontAwesomeIcon icon={faPlus} /> &nbsp;
                {createLabel}
              </ButtonNew>
            ) : null}
          </ButtonGroup>
        </div>
      </div>
    </div>
  );
}
